/* eslint-disable no-underscore-dangle */
class Folder {
  constructor({
    id = -1,
    name = '',
    // If a user selects this folder
    isEditing = false,
    isActive = false,
    sharedBy = '',
    sharedToTeams = [],
    sharedToUsers = [],
    type = '',
  }) {
    this._id = id;
    this._name = name;
    this._isActive = isActive;
    this._isEditing = isEditing;
    this._sharedBy = sharedBy;
    this._sharedToTeams = sharedToTeams;
    this._sharedToUsers = sharedToUsers;
    this._type = type;
    this.setIsShared();
  }

  setIsShared() {
    this._isShared = (this._sharedToTeams.length + this._sharedToUsers.length) > 0;
  }
  /* getters and setters */
  // id
  get id() {
    return this._id;
  }
  set id(val) {
    this._id = val;
  }
  // name
  get name() {
    return this._name;
  }
  set name(val) {
    this._name = val;
  }
  // isEditing
  get isEditing() {
    return this._isEditing;
  }
  set isEditing(val) {
    this._isEditing = val;
  }
  // isActive
  get isActive() {
    return this._isActive;
  }
  set isActive(val) {
    this._isActive = val;
  }
  // sharedBy
  get sharedBy() {
    return this._sharedBy;
  }
  set sharedBy(val) {
    this._sharedBy = val;
  }
  // sharedToTeams
  get sharedToTeams() {
    return this._sharedToTeams;
  }
  set sharedToTeams(val) {
    if (_.isArray(val)) {
      this._sharedToTeams = val;
      this.setIsShared();
    }
  }
  // sharedToUsers
  get sharedToUsers() {
    return this._sharedToUsers;
  }
  set sharedToUsers(val) {
    if (_.isArray(val)) {
      this._sharedToUsers = val;
      this.setIsShared();
    }
  }
  // isShared
  get isShared() {
    return this._isShared;
  }
  // type
  get type() {
    return this._type;
  }
  set type(val) {
    this._type = val;
  }
};

export default Folder;



// WEBPACK FOOTER //
// ./src/views/ReportList/utils/Folder.js